import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row news__wrapper q-col-gutter-x-lg q-col-gutter-y-lg"
}
const _hoisted_2 = { class: "row justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_news_item = _resolveComponent("news-item")!
  const _component_news_skeleton_item = _resolveComponent("news-skeleton-item")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsList, (news, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: news.id,
              class: "col-xs-12 col-sm-6 col-md-4 row news__item-wrapper"
            }, [
              _createVNode(_component_news_item, {
                "is-loading": _ctx.isLoading,
                class: "col-xs-12",
                news: news,
                "icon-number": index
              }, null, 8, ["is-loading", "news", "icon-number"]),
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_news_skeleton_item, {
                    key: 0,
                    class: "col-xs-12"
                  }))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_q_carousel, {
          key: 1,
          modelValue: _ctx.slide,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slide) = $event)),
          "transition-prev": "scale",
          "transition-next": "scale",
          swipeable: "",
          animated: "",
          "control-color": "primary",
          navigation: "",
          infinite: "",
          padding: "",
          class: "news__wrapper"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsList, (news, index) => {
              return (_openBlock(), _createBlock(_component_q_carousel_slide, {
                key: index,
                name: index,
                class: "news__item-wrapper"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_news_item, {
                    class: "col-xs-12 full-height",
                    news: news,
                    "icon-number": index
                  }, null, 8, ["news", "icon-number"])
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "s-link col-auto",
        to: { name: _ctx.newsRouteName }
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "s-text-link" }, " Посмотреть все новости ", -1)),
          _createVNode(_component_s_icon, {
            name: "app:arrow-normal-right",
            class: "s-pl-sm"
          })
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ], 512)), [
    [_vShow, _ctx.newsList.length !== 0]
  ])
}